// Package card section scaffold (single package summary).
import Button from "../../ui/Button";
import { Building2, CheckCircle, Rocket, TrendingUp } from "lucide-react";
import { useLanguage } from "../../../i18n/LanguageContext";

function pickPackageIcon(name = "") {
  const n = String(name);
  // Arabic
  if (n.includes("الانطلاقة")) return Rocket;
  if (n.includes("النمو")) return TrendingUp;
  if (n.includes("التوسع")) return Building2;

  // English
  const lower = n.toLowerCase();
  if (lower.includes("starter") || lower.includes("launch")) return Rocket;
  if (lower.includes("growth")) return TrendingUp;
  if (lower.includes("expansion") || lower.includes("scale")) return Building2;

  return Rocket;
}

export default function PackageCard({
  name,
  desc,
  sections,
  ctaText,
  index = 0,
}) {
  const { t } = useLanguage();
  const Icon = pickPackageIcon(name);
  const isFeatured = index === 1;
  return (
    <div
      className={`package-card ${isFeatured ? "package-card--featured" : ""}`}
      data-aos="fade-up"
      data-aos-delay={index * 120}
    >
      {isFeatured && <div className="package-badge">{t.packages.mostPopular}</div>}

      <div className="package-icon" aria-hidden="true">
        <Icon />
      </div>

      <h3 className="package-name">{name}</h3>
      <p className="package-desc">{desc}</p>

      <div className="package-sections">
        {sections.map((section, idx) => (
          <details key={idx}>
            <summary>{section.summary}</summary>
            <ul>
              {section.items.map((item, itemIdx) => (
                <li key={itemIdx}>
                  <CheckCircle className="package-check" aria-hidden="true" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </details>
        ))}
      </div>

      <Button to="/request" variant="primary" className="package-cta">
        {ctaText}
      </Button>
    </div>
  );
}

